export default "/images/zap-off.svg?836ce2dd046e7891d0756051baa5b923";